// extracted by mini-css-extract-plugin
module.exports = {"container":"JournalActingLsrLevel_container__1y0md","lsrRow":"JournalActingLsrLevel_lsrRow___Lagd","lsrName":"JournalActingLsrLevel_lsrName__1oCfu"};